<template>
  <div class="permission-config-panel">
    <p v-if="showDescription" class="panel-desc">
      协作者控制问卷可见范围；修改权限控制问卷可编辑范围。选择「另行配置」后，可单独指定可修改人。
    </p>
    <el-form :label-width="labelWidth" class="permission-form">
      <el-form-item label="其他协作者">
        <div class="picker-row">
          <span class="selected-count">已选{{ internalValue.assistants.length }}人</span>
          <el-button type="text" class="pick-btn" @click="openPicker('assistant')">选择</el-button>
        </div>
      </el-form-item>

      <el-form-item class="edit-permission-item">
        <span slot="label" class="section-label">
          修改权限
          <el-tooltip class="item" effect="dark" placement="top-start">
            <div slot="content">如另行配置修改权限，可修改人需拥有该问卷的可见权限才允许修改问卷</div>
            <i class="el-icon-question section-help" />
          </el-tooltip>
        </span>
        <el-radio-group v-model="internalValue.editPermissionMode" @change="handleEditModeChange">
          <el-radio label="VIEW_BASED">与查看权限一致</el-radio>
          <el-radio label="CUSTOM">另行配置</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="internalValue.editPermissionMode === 'CUSTOM'" label="可修改人">
        <div class="picker-row">
          <span class="selected-count">已选{{ internalValue.editors.length }}人</span>
          <el-button type="text" class="pick-btn" @click="openPicker('editor')">选择</el-button>
        </div>
      </el-form-item>
    </el-form>

    <user-picker-dialog
      :visible.sync="pickerVisible"
      :title="pickerDialogTitle"
      :value="pickerDraftValue"
      @confirm="handlePickerConfirm"
    />
  </div>
</template>

<script>
import UserPickerDialog, { pickUser } from './user-picker-dialog.vue'

export default {
  name: 'PermissionConfigPanel',
  components: {
    UserPickerDialog
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    showDescription: {
      type: Boolean,
      default: true
    },
    labelWidth: {
      type: String,
      default: '110px'
    }
  },
  data() {
    return {
      internalValue: this.normalizeValue(this.value),
      pickerVisible: false,
      pickerMode: 'assistant',
      hasEnteredCustomMode: false
    }
  },
  computed: {
    pickerDialogTitle() {
      return this.pickerMode === 'assistant' ? '选择其他协作者' : '选择可修改人'
    },
    pickerDraftValue() {
      const key = this.pickerMode === 'assistant' ? 'assistants' : 'editors'
      return this.internalValue[key]
    }
  },
  watch: {
    value: {
      handler(val) {
        this.internalValue = this.normalizeValue(val)
        const mode = val?.editPermissionMode || 'VIEW_BASED'
        if (mode === 'VIEW_BASED') {
          this.hasEnteredCustomMode = false
        } else if (mode === 'CUSTOM') {
          this.hasEnteredCustomMode = true
        }
      },
      deep: true
    }
  },
  methods: {
    normalizeValue(val) {
      return {
        editPermissionMode: val?.editPermissionMode || 'VIEW_BASED',
        assistants: (val?.assistants || []).map((item) => pickUser(item)),
        editors: (val?.editors || []).map((item) => pickUser(item))
      }
    },
    emitChange() {
      this.$emit('input', {
        editPermissionMode: this.internalValue.editPermissionMode,
        assistants: this.internalValue.assistants.map((item) => pickUser(item)),
        editors: this.internalValue.editors.map((item) => pickUser(item))
      })
    },
    handleEditModeChange(mode) {
      if (mode === 'CUSTOM' && !this.hasEnteredCustomMode) {
        this.internalValue.editors = this.internalValue.assistants.map((item) => pickUser(item))
        this.hasEnteredCustomMode = true
      }
      this.emitChange()
    },
    openPicker(mode) {
      this.pickerMode = mode
      this.pickerVisible = true
    },
    handlePickerConfirm(selected) {
      const key = this.pickerMode === 'assistant' ? 'assistants' : 'editors'
      this.internalValue[key] = selected.map((item) => pickUser(item))
      this.emitChange()
    }
  }
}
</script>

<style lang="scss" scoped>
.permission-config-panel {
  .panel-desc {
    margin: 0 0 16px;
    color: #909399;
    font-size: 13px;
    line-height: 1.5;
  }

  .permission-form {
    ::v-deep .section-title-item {
      margin-bottom: 4px;

      .el-form-item__content {
        display: none;
      }

      .el-form-item__label {
        font-weight: 600;
        line-height: 32px;
      }
    }

    ::v-deep .edit-permission-item {
      .el-form-item__label {
        font-weight: 600;
        line-height: 32px;
      }
    }

    .section-label {
      display: inline-flex;
      align-items: center;
    }

    .section-help {
      margin-left: 4px;
      color: #c0c4cc;
      font-size: 14px;
      cursor: pointer;
      font-weight: normal;
    }

    ::v-deep .el-form-item__label {
      text-align: right;
      color: #303133;
    }
  }
}

.picker-row {
  display: flex;
  align-items: center;
  min-height: 32px;

  .selected-count {
    color: #909399;
    font-size: 14px;
    margin-right: 12px;
  }
}

.pick-btn {
  padding: 0;
  color: #00a3ff;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover,
  &:focus {
    color: #33b5ff;
  }
}

.edit-permission-item {
  ::v-deep .el-radio {
    margin-right: 24px;
  }
}
</style>
